const imageCompression = (await import("browser-image-compression")).default;
import { getSupabase } from "../lib/supabase";

export async function uploadInsightImage(file) {
  // 1️⃣ Compress image (safe + sharp)
  const compressed = await imageCompression(file, {
    maxSizeMB: 0.6,
    maxWidthOrHeight: 1800,
    useWebWorker: true,
  });

  // 2️⃣ Generate path
  const ext = compressed.name.split(".").pop();
  const filePath = `updates/${crypto.randomUUID()}.${ext}`;

  const supabase = await getSupabase();

  // 3️⃣ Upload to PRIVATE bucket
  const { error } = await supabase.storage
    .from("insights") // ✅ correct bucket
    .upload(filePath, compressed, {
      cacheControl: "3600",
      upsert: false,
      contentType: compressed.type,
    });

  if (error) throw error;

  // 4️⃣ Store ONLY file path in DB (best practice)
  return filePath;
}
